/* ==========================================================================
   RIWAAYAT — Cart drawer, quick add, money formatting
   Uses the Shopify AJAX Cart API. Also listens to the theme's `cart:update`
   event so legacy quick-add buttons keep the drawer + count in sync.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.rwCart || {};
  var moneyFormat = cfg.moneyFormat || '₹{{amount}}';
  var freeShip = parseInt(cfg.freeShippingThreshold || 0, 10); // in cents
  var routes = window.rwRoutes || { cart: '/cart', add: '/cart/add', change: '/cart/change', root: '/' };

  /* ---------------- Money ---------------- */
  function formatWithDelimiters(num, precision, thousands, decimal) {
    thousands = thousands || ','; decimal = decimal || '.';
    if (isNaN(num) || num == null) return '0';
    num = (num / 100).toFixed(precision);
    var parts = num.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  function money(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': val = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: val = formatWithDelimiters(cents, 2);
    }
    /* Clean trailing .00 for a calmer luxury read */
    val = val.replace(/\.00$/, '');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }
  window.rwMoney = money;

  /* ---------------- DOM refs ---------------- */
  var drawer = document.querySelector('.rw-drawer');
  var body = drawer && drawer.querySelector('.rw-drawer__body');
  var foot = drawer && drawer.querySelector('.rw-drawer__foot');
  var countEls = function () { return document.querySelectorAll('[data-rw-cart-count]'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var img = function (url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 240); };

  function setCount(n, bump) {
    countEls().forEach(function (el) {
      el.textContent = n; el.setAttribute('data-count', n);
      if (bump) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
    var title = drawer && drawer.querySelector('[data-rw-drawer-count]');
    if (title) title.textContent = n;
  }

  /* ---------------- Render ---------------- */
  function render(cart) {
    if (!drawer) return;
    setCount(cart.item_count);
    var ship = drawer.querySelector('.rw-ship');
    if (ship && freeShip > 0) {
      var remaining = freeShip - cart.total_price;
      var pct = Math.min(cart.total_price / freeShip, 1);
      ship.querySelector('.rw-ship__msg').innerHTML = remaining > 0
        ? 'You are <strong>' + money(remaining) + '</strong> away from complimentary shipping'
        : '<strong>Complimentary shipping</strong> unlocked — on us.';
      ship.querySelector('.rw-ship__bar span').style.transform = 'scaleX(' + pct + ')';
      ship.hidden = cart.item_count === 0;
    }
    if (!cart.item_count) {
      body.innerHTML = drawer.querySelector('template[data-rw-empty]').innerHTML;
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (item, i) {
      var opts = (item.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return esc(/size/i.test(o.name) ? 'Size' : o.name) + ': ' + esc(o.value); }).join(' · ');
      var compare = item.original_price < (item.variant_compare_at_price || 0) ? item.variant_compare_at_price * item.quantity : 0;
      return '<div class="rw-line" style="animation-delay:' + (i * 0.05) + 's" data-key="' + esc(item.key) + '">' +
        '<a class="rw-line__img" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(img(item.image, 240)) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div>' +
          '<a class="rw-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (opts ? '<div class="rw-line__variant">' + opts + '</div>' : '') +
          '<div class="rw-price" style="margin-top:6px"><span class="rw-price__now">' + money(item.final_line_price) + '</span>' +
            (compare ? '<span class="rw-price__mrp">' + money(compare) + '</span>' : '') + '</div>' +
          '<div class="rw-line__row">' +
            '<div class="rw-qty" role="group" aria-label="Quantity">' +
              '<button type="button" data-rw-qty="-1" aria-label="Decrease quantity">−</button>' +
              '<span aria-live="polite">' + item.quantity + '</span>' +
              '<button type="button" data-rw-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="rw-line__remove" data-rw-remove>Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    var total = foot.querySelector('[data-rw-total]');
    if (total) total.textContent = money(cart.total_price);
    var savings = foot.querySelector('[data-rw-savings]');
    if (savings) {
      var saved = cart.items.reduce(function (acc, it) {
        var c = it.variant_compare_at_price || 0;
        return acc + (c > it.original_price ? (c - it.original_price) * it.quantity : 0);
      }, 0) + (cart.total_discount || 0);
      savings.textContent = saved > 0 ? 'You save ' + money(saved) + ' on this order' : '';
    }
  }

  function fetchCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refresh() { return fetchCart().then(function (c) { render(c); return c; }); }

  /* ---------------- Open / close ---------------- */
  function open() {
    if (!drawer) { window.location.href = routes.cart; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (window.rwLock) window.rwLock(true);
    setTimeout(function () { var c = drawer.querySelector('.rw-drawer__close'); c && c.focus(); }, 300);
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (window.rwLock) window.rwLock(false);
  }
  window.rwCartOpen = function () { refresh().then(open); };

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-rw-drawer-close]')) { close(); return; }
      var line = e.target.closest('.rw-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyBtn = e.target.closest('[data-rw-qty]');
      var rm = e.target.closest('[data-rw-remove]');
      if (!qtyBtn && !rm) return;
      var current = parseInt(line.querySelector('.rw-qty span').textContent, 10) || 0;
      var next = rm ? 0 : Math.max(0, current + parseInt(qtyBtn.getAttribute('data-rw-qty'), 10));
      if (next === 0) line.classList.add('is-removing');
      line.style.opacity = '0.6';
      fetch(routes.change + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: next }),
      }).then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.status && cart.status >= 400) { window.rwToast && window.rwToast(cart.description || 'Could not update bag'); return refresh(); }
          render(cart);
          document.dispatchEvent(new CustomEvent('rw:cart:changed', { detail: { cart: cart } }));
        })
        .catch(function () { refresh(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }
  document.querySelectorAll('[data-rw-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); window.rwCartOpen(); });
  });

  /* ---------------- Add to cart ---------------- */
  window.rwAdd = function (items, opts) {
    opts = opts || {};
    return fetch(routes.add + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to bag');
        if (opts.checkout) { window.location.href = (routes.root || '/').replace(/\/$/, '') + '/checkout'; return; }
        return fetchCart().then(function (cart) {
          render(cart); setCount(cart.item_count, true);
          if (opts.openDrawer !== false) open();
          return cart;
        });
      });
  };

  /* Quick add buttons on cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rw-quick-add]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var label = btn.querySelector('span');
    var orig = label ? label.textContent : '';
    window.rwAdd([{ id: parseInt(btn.getAttribute('data-rw-quick-add'), 10), quantity: 1 }])
      .then(function () {
        btn.classList.add('is-added');
        if (label) label.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = orig; }, 1800);
      })
      .catch(function (err) { window.rwToast && window.rwToast(err.message); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  /* Keep in sync with legacy theme components */
  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {};
    if (d.sourceId && String(d.sourceId).indexOf('rw-') === 0) return;
    refresh().then(function () {
      if (d.data && d.data.source && /product-form|quick-add/i.test(d.data.source)) open();
    });
  });

  /* Initial count sync (handles back/forward cache) */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
